import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';

import { getNav4OptOutCache, getNav4GAOptInCache } from './useNav4OptOut.ts';
import { getNav4GAPhase } from './getNav4GAPhase.ts';
import { getNav4AdminOptInCache } from './nav4AdminOptInCache.ts';

/**
 * YOU SHOULD PROBABLY CALL `useIsNav4Enabled` INSTEAD OF THIS FUNCTION.
 * Please check with #cc-disco before using.
 */

/**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              useIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/
// eslint-disable-next-line confluence-feature-gating/inline-usage
export const getIsNav4Enabled = () => {
	const currentGAPhase = getNav4GAPhase();
	if (currentGAPhase === 2) {
		return true;
	}

	if (getNav4OptOutCache()) {
		return false;
	}

	return (
		// checks both site opt-in and admin only opt-in
		fg('confluence_nav_4') ||
		expVal('confluence_jira_nav4_new_customers', 'willShowNav4', false) ||
		(currentGAPhase === 1 && (getNav4AdminOptInCache() || getNav4GAOptInCache()))
	);
};
